import UyelerveAraclarSvg from "../../components/icons/sidebar/UyelerveAraclarSvg"
import SurucuVeAraclarSvg from "../../components/icons/sidebar/SurucuVeAraclarSvg"
import HesaplamalarSvg from "../../components/icons/sidebar/HesaplamalarSvg"
import EArsivFaturaSvg from "../../components/icons/sidebar/EArsivFaturaSvg"
import UygunSigortaBulSvg from "../../components/icons/sidebar/UygunSigortaBulSvg"
import IlanlarSvg from "../../components/icons/sidebar/IlanlarSvg"
import SariSayfalarSvg from "../../components/icons/sidebar/SariSayfalarSvg"
import KasaDefteriSvg from "../../components/icons/sidebar/KasaDefteriSvg"
import RaporlarSvgg from "../../components/icons/sidebar/RaporlarSvgg"
import ProfilimSvg from "../../components/icons/sidebar/ProfilimSvg"
import EgeyurtAdminSvg from "../../components/icons/sidebar/EgeyurtAdminSvg"
import KaraListeSvg from "../../components/icons/sidebar/KaraListeSvg"
import DestekGeriBildirimSvg from "../../components/icons/sidebar/DestekGeriBildirimSvg"
import HakkindaSvg from "../../components/icons/sidebar/HakkindaSvg"
import YukIslemleriSvg from "../../components/icons/sidebar/YukIslemleriSvg"
import YukIslemleriSvgLarge from "../../components/icons/sidebarLarge/YukIslemleriSvgLarge"
import UyelerveAraclarSvgLarge from "../../components/icons/sidebarLarge/UyelerveAraclarSvgLarge"
import UygunSigortaBulSvgLarge from "../../components/icons/sidebarLarge/UygunSigortaBulSvgLarge"
import SariSayfalarSvgLarge from "../../components/icons/sidebarLarge/SariSayfalarSvgLarge"
import RaporlarSvgLarge from "../../components/icons/sidebarLarge/RaporlarSvgLarge"
import ProfilimSvgLarge from "../../components/icons/sidebarLarge/ProfilimSvgLarge"
import KasaDefteriSvgLarge from "../../components/icons/sidebarLarge/KasaDefteriSvgLarge"
import KaraListeSvgLarge from "../../components/icons/sidebarLarge/KaraListeSvgLarge"
import IlanlarSvgLarge from "../../components/icons/sidebarLarge/IlanlarSvgLarge"
import HesaplamalarSvgLarge from "../../components/icons/sidebarLarge/HesaplamalarSvgLarge"
import HakkindaSvgLarge from "../../components/icons/sidebarLarge/HakkindaSvgLarge"
import EgeyurtAdminSvgLarge from "../../components/icons/sidebarLarge/EgeyurtAdminSvgLarge"
import EArsivFaturaSvgLarge from "../../components/icons/sidebarLarge/EArsivFaturaSvgLarge"
import SurucuVeAraclarSvgLarge from "../../components/icons/sidebarLarge/SurucuVeAraclarSvgLarge"
import DestekGeriBildirimSvgLarge from "../../components/icons/sidebarLarge/DestekGeriBildirimSvgLarge"
import UETDSSvg from "../../components/icons/sidebar/UETDSSvg"
import UETDSSvgLarge from "../../components/icons/sidebarLarge/UETDSSvgLarge"
import AiSvg from "../../components/icons/sidebar/AiSvg"

  export const showedMenusIcons = [
    {
      text: "yuk-islemleri",
      icon: <YukIslemleriSvg/>,
      iconLarge: <YukIslemleriSvgLarge/>,
    },
    {
      text: "uyeler-ve-araclar",
      icon: <UyelerveAraclarSvg/>,
      iconLarge: <UyelerveAraclarSvgLarge/>,
    },
    {
      text: "suruculer-ve-araclarim",
      icon: <SurucuVeAraclarSvg/>,
      iconLarge: <SurucuVeAraclarSvgLarge/>,
    },
    {
      text: "hesaplamalar",
      icon: <HesaplamalarSvg/>,
      iconLarge: <HesaplamalarSvgLarge/>,
    },
    {
      text: "e-arsiv",
      icon: <EArsivFaturaSvg/>,
      iconLarge: <EArsivFaturaSvgLarge/>,
    },
    {
      text: "uygun-sigorta-bul",
      icon: <UygunSigortaBulSvg/>,
      iconLarge: <UygunSigortaBulSvgLarge/>,
    },
    {
      text: "ilanlar",
      icon: <IlanlarSvg/>,
      iconLarge: <IlanlarSvgLarge/>,
    },
    {
      text: "sari-sayfalar",
      icon: <SariSayfalarSvg/>,
      iconLarge: <SariSayfalarSvgLarge/>,
    },
    {
      text: "kasa-defteri",
      icon: <KasaDefteriSvg/>,
      iconLarge: <KasaDefteriSvgLarge/>,
    },
    {
      text: "u-etds-yuk-bildirimi",
      icon: <UETDSSvg/>,
      iconLarge: <UETDSSvgLarge/>,
    },
    {
      text: "raporlar",
      icon: <RaporlarSvgg/>,
      iconLarge: <RaporlarSvgLarge/>,
    },
    {
      text: "profilim",
      icon: <ProfilimSvg/>,
      iconLarge: <ProfilimSvgLarge/>,
    },
    {
      text: "admin",
      icon: <EgeyurtAdminSvg/>,
      iconLarge: <EgeyurtAdminSvgLarge/>,
    },
    {
      text: "engellenen-suruculer",
      icon: <KaraListeSvg/>,
      iconLarge: <KaraListeSvgLarge/>,
    },
    {
      text: "mesajlar",
      icon: <DestekGeriBildirimSvg/>,
      iconLarge: <DestekGeriBildirimSvgLarge/>,
    },
    {
      text: "hakkinda",
      icon: <HakkindaSvg/>,
      iconLarge: <HakkindaSvgLarge/>,
    },
    {
      text: "akilli-kamyoon",
      icon: <AiSvg/>,
      iconLarge: <AiSvg/>,
    }
  ]

